import gql from "graphql-tag";

export const accessGroupFormStoragesQuery = gql`
  query accessGroupFormStorages {
    storages {
      id
      name
    }
  }
`;
